import React, { useState, useEffect } from "react";
import {
  Grid, Box, List, ListItem, ListItemText,
  TextField,
} from '@mui/material';
import http from "../../utils/http-common";
import { useNavigate, useLocation } from "react-router-dom";
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '../../assets/planshare icons/close.png';
import SearchIcon from '../../assets/planshare icons/search.png';
import SearchTemplatePage from "./SearchTemplatePage";
import { useDispatch } from "react-redux";
import { setTemplateForCreate } from "../../Slices/planslice";
function Templates({ drawerOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const Categories = ["Aerospace", "Construction", "Pharmaceutical", "Oil & Gas", "Automobile", "Power & utility", "Healthcare", "Telecom", "Finance", "Insurance", "Road", "Retail Supply chain", "Software", "Heavy Machine", "Chemical", "Nuclear", "Electronics", "Ship building", "Mining",
    "Agriculture"];

  const [selectedCategory, setSelectedCategory] = useState(["All Category", ...Categories]);
  const [showSearch, setShowSearch] = useState(false);
  useEffect(() => {
    FetchAllProducts();
  }, []);

  const [categoriesData, setCategoriesData] = useState([])
  const [categoriesFilter, setCategoriesFilter] = useState([])
  const FetchAllProducts = async () => {
    const payload = { metadata_type: "category" };
    try {
      const response = await http.post(
        "/master_service/template/category_list",
        payload
      );
      const uniqueCategories = response.data.data.map(
        (types) => types.metadata_name
      );
      setCategoriesFilter([...uniqueCategories]);
    } catch (e) {
      console.error("error", e);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("");
  const [filteredTemplate, setFilteredTemplate] = useState([]);

  const dispatch = useDispatch();

  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300); // Delay of 300ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };
  const username = localStorage.getItem("user_name");
  const filterTemplateSearch = async (category = selectedCategory, term = searchTerm, sort = sortOption) => {
    const lowercasedTerm = term.toLowerCase();
    try {
      const response = await http.get(
        `/master_service/search/template?search=${lowercasedTerm || category}`);
      const searchData = response.data.data;
      setFilteredTemplate(searchData);
    } catch (e) {
      console.error("error", e);
    }
  };


  const [showResult, setShowResult] = useState(false);

  const handleSearch = () => {
    setShowResult(true);
    setShowSearch(true);
    filterTemplateSearch();
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const handleNavigation = () => {
    navigate("/home/createplan");
    dispatch(setTemplateForCreate({ isTemplate: true,
      table: false, }));
  };


  return (
    <div style={{ height: "100vh" }}>
      {/* Header Section */}
      <Grid
        container
        spacing={2}
        sx={{
          backgroundColor: "rgba(255, 192, 203, 0.5)", // Semi-transparent pink
          minWidth: "85vw",
          fontFamily: "Inter, sans-serif",
          fontWeight: 500,
          fontSize: "12px",
          color: "black", // Ensure text remains unaffected
          textAlign: "left",
          transition: "width 0.3s ease",
        }}
      >
        <Grid item xs={12} sx={{ marginBottom: "10px" }}>
          Wanted to share your templates in Planshare community?{" "}
          <span
            onClick={handleNavigation}
            style={{
              color: "#FF2800",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Create template
          </span>
        </Grid>
      </Grid>

      {/* Content Section */}
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          textAlign: "center",
          fontFamily: "Inter, sans-serif",
          width: drawerOpen ? "95vw" : "82vw", // Adjust width dynamically
          transition: "width 0.3s ease",
        }} // Center text vertically and horizontally
      >
        <Grid item>
          <h3 style={{fontSize: "24px"}}>Your Hub for Project Templates</h3>
          <p style={{fontSize: "20px"}}>Find and contribute templates to streamline workflows and boost productivity.</p>
        </Grid>
      </Grid>

      {/* Search Section */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={2}
        sx={{
          marginTop: "10px",
          fontFamily: "Inter, sans-serif",
          position: "relative",
          width: drawerOpen ? "95vw" : "81vw", // Adjust width dynamically
          transition: "width 0.3s ease",
        }}
      >
        <Box display="flex" justifyContent="flex-end" alignItems="center" width="100%">
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search for templates like 'project template'"
            value={searchTerm}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setShowResult(false);
            }}
            sx={{
              marginRight: "10px",
              width: drawerOpen ? "60vw" : "73vw", // Adjust width dynamically
              transition: "width 0.3s ease",
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <button
                    onClick={() => {
                      setSearchTerm("");
                      setShowResult(false); // Clear result text when clearing search
                    }}
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={CloseIcon} // Replace this with your close icon path
                      alt="clear"
                      style={{ width: '16px', height: '16px' }}
                    />
                  </button>
                </InputAdornment>
              ),
            }}
          />
          <button
            onClick={handleSearch}
            style={{
              fontFamily: "Inter, sans-serif",
              padding: "10px 25px",
              backgroundColor: "#FF2800",
              color: "white",
              border: "none",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </Box>


        {filteredResults.length > 0 && (
          <List
            sx={{
              position: "absolute",
              top: "calc(100% - 15px)", // Position directly below the search bar with some spacing
              left: "4%",
              width: "80vw",
              backgroundColor: "white",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              borderRadius: "20px 20px",
              zIndex: 10,
            }}
          >
            {filteredResults.map((item) => (
              <ListItem
                key={item.id}
                button
                sx={{
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <ListItemText
                  primary={
                    <span>
                      {item.name.split(new RegExp(`(${debouncedSearchTerm})`, "i")).map((part, index) =>
                        part.toLowerCase() === debouncedSearchTerm.toLowerCase() ? (
                          <strong key={index} style={{ color: "#FF2800" }}>
                            {part}
                          </strong>
                        ) : (
                          part
                        )
                      )}
                    </span>
                  }
                  secondary={`Category: ${item.category}, Author: ${item.author}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Box>
      <Box marginTop={3}>
        <SearchTemplatePage handleSearch={handleSearch} drawerOpen={drawerOpen} showResult={showResult} setShowResult={setShowResult} setShowSearch={setShowSearch} setFilteredTemplate={setFilteredTemplate} selectedCategory={selectedCategory} showSearch={showSearch} setSelectedCategory={setSelectedCategory} categoriesFilter={categoriesFilter} setCategoriesFilter={setCategoriesFilter} categoriesData={categoriesData} searchTerm={searchTerm} filterTemplateSearch={filterTemplateSearch} filteredTemplate={filteredTemplate} setSortOption={setSortOption} sortOption={sortOption} />
      </Box>

    </div>
  );
}

export default Templates;
  